<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataOverview")
    h1.title Mietobjekte
    .sub-headline Hier sehen Sie alle Ihre Objekte, Ferienwohnungen und Ferienhäuser.
    
    .button-wrapper.margin-top      
      b-dropdown(hoverable='' aria-role='list')
        button.button.is-light(slot='trigger')
          span Neues Mietobjekt anlegen
          b-icon(icon='menu-down')
        b-dropdown-item(v-for="type in rentObjectTypes" :key="type.id" aria-role='listitem' @click="$router.push({name: 'DataRentObjectNew', params: {rentObjectTypeId: type.id}})")
          .media
            b-icon(class="media-left" :icon='type.icon')
            .media-content
              h3 {{type.name}}
      b-button(type="is-light" icon-left="shuffle" @click="$router.push({name: 'DataRentObjectsAdminSort'})") Sortierung Buchungskalender
      b-button(type="is-light" icon-left="share-variant" @click="$router.push({name: 'DataRentObjectChannels'})") Channel Manager

    .card.margin-top
      #main
        b-table(
                :data="rentObjects"
                default-sort-direction="asc"
                default-sort="code"
                hoverable
                @click="row => $router.push({ name: 'DataRentObjectEdit', params: { id: row.id } })")
          b-table-column(field='code', :id.native="'test'", label='Code' width='40' sortable, centered, searchable, v-slot="props")
            b-tag(type="is-light")
              b {{ props.row.code }}
          b-table-column(field='rentObjectType.name' label='Typ' width='40' sortable, v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObjectType.icon")
              p.icon-name {{props.row.rentObjectType.name}}
          b-table-column(field='name' label='Titel' sortable, searchable, v-slot="props")
            | {{ props.row.name }}
          b-table-column(field='street' label='Adresse' sortable, v-slot="props")
            | {{ props.row.street }} {{ props.row.city }}
          b-table-column(label='Webseite' sortable, v-slot="props")
            b-icon(v-if="props.row.activeWebsite" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
          b-table-column(label='Admin' sortable, v-slot="props")
            b-icon(v-if="props.row.activeAdmin" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
          b-table-column(v-slot="props")
            div
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="$router.push({ name: 'DataRentObjectEdit', params: { id: props.row.id } })")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deleteRentObject(props.row)")
</template>

<script> 
export default {
  data() {
    return {
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    }
  },
  methods: {
    deleteRentObject(row) {
      this.$buefy.dialog.confirm({
        title: "Mietobjekt löschen",
        message: `Sind Sie sicher, dass Sie das Mietobjekt <b>${row.code} ${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Mietobjekt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjects/delete", { id: row.id });
            this.$buefy.toast.open("Mietobjekt gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Mietobjekt konnte nicht gelöscht werden."
            );
          }
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.$store.dispatch("rentObjectTypes/findAll");
    this.$nextTick(() => {
      // Code-Search should be on focus when the page loads
      const inputs = document.getElementById('main').getElementsByClassName("input");
      inputs[0].focus();
    });
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>